type FifoCache<TKey, TValue> = (key: TKey) => TValue;

/**
 * Returns a function which will return the cached results of subsequent calls with an identical argument.
 */
export const createFifoCache = <TKey, TValue>(
  limit: number,
  createValue: (key: TKey) => TValue
): FifoCache<TKey, TValue> => {
  const map = new Map<TKey, TValue>();
  return (key: TKey) => {
    if (map.has(key)) {
      return map.get(key)!;
    }
    const value = createValue(key);
    map.set(key, value);
    if (map.size > limit) {
      const [firstKey] = map.keys();
      map.delete(firstKey);
    }
    return value;
  };
};
